class Cart {
    init() {
        let $cartForm = $('#cartForm');
        let self = this;
        $cartForm.on('keypress', '.update_amount',  event => {
            if (event.which === 13) {
                this.send_cartform($cartForm);
                return true;
            }
            $(event.target).focusout(() => {
                this.send_cartform($cartForm);
            });

            return true;
        });
        // here to prevent form twice submitting
        $('.createOrderStep button').on('click', function (event) {
            event.preventDefault();
            this.disabled = true;
            this.form.submit();
        });
        $('.cartTable').on('click', 'span.add, span.minus',  function(event){
            let _this = $(this);
            let updateAmount = _this.parent('.counter').find('.update_amount');
            let currentAmount = +updateAmount.val();
            let originalEvent;
            //Fix send action to google analytics
            updateAmount.trigger('click');
            if (_this.hasClass('add')) {
                updateAmount.val( currentAmount + 1);
            } else {
                updateAmount.val(currentAmount - 1);
            }
            //Fix for ie 11. It hasn't Event
            if(typeof(Event) === 'function') {
                originalEvent = new Event('change');
            }else{
                originalEvent = document.createEvent('Event');
                originalEvent.initEvent('change', true, true);
            }

            let e = $.Event( "change", { keyCode: 48,  originalEvent:originalEvent});

            updateAmount.trigger(e);
            updateAmount.trigger('blur');
            self.send_cartform($('#cartForm'));
        });

        $('.buttonContainer').on('click', '#send-next-step', function (event) {
            $('#next-step').submit();
        });

        this.init_coupon($cartForm);
    }

    send_cartform( $cartForm){
        $cartForm.find(':input:hidden').not('input[type="hidden"]').prop('disabled', true);

        $.ajax({
            url: $cartForm.attr('action'),
            data: $cartForm.serialize() + '&step=' + $('#step').val(),
            type: 'post',
            success: data => {
                $cartForm.find('.cartLines,.bundle').remove();
                $cartForm.find('.cartTable tbody').append(data.products);
                $('table.total-prices').html(data.totalProducts);
                $('.couponCode').replaceWith(data.coupon);
                this.init_coupon($cartForm);
            }
        });

    }

    init_coupon($cartForm) {
        $('#couponForm').on('click', '.button',  event => {
            this.send_cartform($cartForm);
            $('#discounts').not('.is-active').addClass('is-active');
        });
    }
}

$(document).ready(function () {
    let cart = new Cart();
    cart.init();
});